import * as React from 'react'
import { connect } from 'react-redux'
import { Title } from '../../components/pageTitle/title'
import {
  metaDataSelector,
  seasonsSelector,
  synopsisSelector,
  titleComponentSelector,
  atfCriticalDataSelector,
  liveStateDataSelector,
  renderOnlyGen4PlaybackInAtfSelector,
  bottomBarSelector,
  heroshotShouldBeShownSelector
} from '../../selectors/component/atfComponentSelectors'
import { Container } from '@amzn/dvui/dist/Container'
import { AtfSynopsis } from '../../components/synopsis/synopsis'
import { Seasons } from '../../components/seasonSelector/seasons'
import { Badges } from './badgesComponent'
import { ActionBox } from './actionBox'
import { Heroshot } from '../../components/heroshot/heroshot'
import * as st from './atfComponent.module.scss'
import { AtfProductMetaInfo } from '../../components/productMetaInfo/atfProductMetaInfo'
import { OnlyPlaybackAvailableInGen4Message, PageUnavailable } from '../../components/pageUnavailable/pageUnavailable'
import { IDetailPageState } from '../../reducers'
import { LiveState } from '../../components/liveState/liveState'
import { BannerPromo } from '../../components/creative/bannerPromo/bannerPromo'
import { bannerPromoSelector, heroQuickPromoSelector } from '../../selectors/creative'
import { HeroQuickPromo } from '../../components/creative/heroQuickPromo/heroQuickPromo'
import { BundleCarousel } from '../../components/bundleCarousel/bundleCarousel'
import { pageSelectors, simpleSelectors } from '../../selectors/basicState'
import { CrowBanner } from '../../components/crowBanner/crowBanner'
import { crowBannerSelector } from '../../selectors/crowBanner'
import { blockedPageSelector } from '../../selectors/component/pageBlockComponentSelectors'
import { PageBlock } from '../../components/pageBlock/pageBlock'
import { BannerContainer } from '../../components/bannerContainer/bannerContainer'
import { UiBanner } from '../../components/uiBanner/uiBanner'
import { sanitizedRequestContextSelector } from '../../selectors/requestContext'
import { Player } from '../../components/player/player'
import { BottomBar } from '../../components/bottomBar/bottomBar'
import { isTreatment } from '../../utils/utils'
import * as cn from 'classnames'
import { ConditionalWrapper } from '../../utils/conditionalWrapper'
import { spacerAlignItems, Spacer } from '@amzn/dvui/dist/Spacer'
import { isDeeplinkableActionReadySelector, isMShopSelector } from '../../selectors/pageContext'
import {
  ageVerificationSelector,
  playbackMessagingComponentSelector,
  trailerComponentSelector
} from '../../selectors/component/actionBoxComponentSelectors'
import { Trailer } from '../../components/playback/trailer'
import { Watchlist } from '../../components/watchlist/watchlist'
import { AtfTreatmentProps } from '../../reducers/features'
import { PlaybackMessaging } from '../../components/playbackMessaging/playbackMessaging'
import * as stUtility from '../../components/utilityClasses.module.scss'
import { AgeVerification } from '../../components/ageVerification/ageVerification'
import { Packshot } from '../../components/packshot/packshot'

type Props = ReturnType<typeof mapStateToProps>
interface AtfWrapperProps{
  children: React.ReactChild | React.ReactChild[]
}

const Atf = ({
  hasCritical,
  renderOnlyGen4PlaybackInAtf,
  title,
  metaData,
  synopsis,
  seasons,
  liveState,
  bannerPromo,
  heroQuickPromo,
  bundleCarousel,
  crowBanner,
  blockedPage,
  isRetail,
  pageContext,
  bottomBar,
  atfTreatment,
  isDeeplinkableActionReady,
  trailerAction,
  isMshop,
  playbackMessaging,
  heroshotShouldBeShown,
  ageVerification,
}: Props) => {

  if (blockedPage) {
    return (
      <AtfWrapper atfTreatment={atfTreatment}>
        <div className={'av-detail-section'}>
          <PageBlock {...blockedPage} />
        </div>
      </AtfWrapper>
    )
  }
  if (!hasCritical) {
    return (
      <AtfWrapper atfTreatment={atfTreatment}>
        <div className={'av-detail-section'}>
          <PageUnavailable />
        </div>
      </AtfWrapper>
    )
  }

  return (
    <div className={st.mainWrapper}>
      <BannerContainer isRetail={isRetail}>
        {crowBanner && <CrowBanner {...crowBanner} />}
        <UiBanner />
      </BannerContainer>
      <AtfWrapper atfTreatment={atfTreatment}>
        <ConditionalWrapper condition={isTreatment(atfTreatment, 'T1', 'T2', 'T3')} wrapper={children => <div className={st.ieCompatibilityWrapper}>{children}</div>}>
          <ConditionalWrapper condition={isTreatment(atfTreatment, 'T1', 'T2', 'T3')} wrapper={children => <div className={isMshop ? st.atfWrapperMshop : st.atfWrapper}>{children}</div>}>
            <ConditionalWrapper condition={isTreatment(atfTreatment, 'T1', 'T2', 'T3')} wrapper={children => <div className={st.atfTop}>{children}</div>}>
            {!global.__NATIVEAPP__ && bannerPromo && <BannerPromo {...bannerPromo} />}
            </ConditionalWrapper>
            <ConditionalWrapper condition={isTreatment(atfTreatment, 'T1', 'T2', 'T3')} wrapper={children => <div className={st.atfMiddle}>{children}</div>}>
              <Heroshot />
              <Packshot />
            </ConditionalWrapper>
            <ConditionalWrapper condition={isTreatment(atfTreatment, 'T1', 'T2', 'T3')} wrapper={children => <div className={cn(st.atfBottom, heroshotShouldBeShown ? st.heroDisplayed : st.packshotDisplayed)}>{children}</div>}>
              <div className={cn('av-detail-section', {
                [st.detailSection]: isTreatment(atfTreatment, 'T1', 'T2', 'T3'),
                [st.heroSection]: !isTreatment(atfTreatment, 'T1', 'T2', 'T3') && heroshotShouldBeShown,
                [st.packSection]: !isTreatment(atfTreatment, 'T1', 'T2', 'T3') && !heroshotShouldBeShown
              })}>
                <div className={isTreatment(atfTreatment, 'T1', 'T2', 'T3') ? st.atfContainerGrid : st.atfContainer}>
                  {renderOnlyGen4PlaybackInAtf && (
                    <OnlyPlaybackAvailableInGen4Message />
                  )}
                  {liveState && <LiveState {...liveState} />}
                  <Title {...title} atfTreatment={atfTreatment}/>
                  <ConditionalWrapper condition={isTreatment(atfTreatment, 'T1', 'T2', 'T3')} wrapper={children => <div className={st.seasonAndBadges}>{children}</div>}>
                    {seasons && <Seasons {...seasons} atfTreatment={atfTreatment}/>}
                    <Badges atfTreatment={atfTreatment}/>
                  </ConditionalWrapper>
                  {isTreatment(atfTreatment, 'T1', 'T2', 'T3') &&
                    <div className={st.atfMessages}>
                        <PlaybackMessaging {...playbackMessaging} atfTreatment={atfTreatment} removeMessagesWithLogo={true}/>
                        <AgeVerification {...ageVerification}/>
                    </div>
                  }
                  {isTreatment(atfTreatment, 'T1', 'T2', 'T3') && <ActionBoxWrapper atfTreatment={atfTreatment}/>}
                  {isTreatment(atfTreatment, 'T1', 'T2', 'T3') &&
                  <Spacer alignItems={spacerAlignItems.top} className={st.watchlistAndTrailerRedesign}>
                    {isDeeplinkableActionReady && trailerAction && <Trailer {...trailerAction} atfTreatment={atfTreatment}/>}
                      <Watchlist/>
                  </Spacer>
                  }
                  {synopsis && <AtfSynopsis {...synopsis} atfTreatment={atfTreatment}/>}
                  {metaData && <AtfProductMetaInfo {...metaData} atfTreatment={atfTreatment}/>}
                  {!isTreatment(atfTreatment, 'T1', 'T2', 'T3') && <ActionBoxWrapper/>}
                  {heroQuickPromo && <HeroQuickPromo {...heroQuickPromo} atfTreatment={atfTreatment}/>}
                </div>
              </div>
              {bundleCarousel && <BundleCarousel {...bundleCarousel} atfTreatment={atfTreatment}/>}
              {bottomBar && <BottomBar {...bottomBar} atfTreatment={atfTreatment}/>}
            </ConditionalWrapper>
          </ConditionalWrapper>
        </ConditionalWrapper>
      </AtfWrapper>
      {[
        pageContext.playbackLaunchType,
        pageContext.playbackTrailerLaunchType,
      ].includes('EMBEDDED') && <Player />}
    </div>
  )
}

const AtfWrapper = ({children, atfTreatment}: AtfWrapperProps & AtfTreatmentProps) =>
  <Container className={cn(st.atfWidgetsWrapper, 'av-dp-container', {[st.pageSection]: !isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}>
    {children}
  </Container>

const ActionBoxWrapper = ({ atfTreatment }: AtfTreatmentProps) =>
  <div id="dv-action-box-wrapper" className={cn(stUtility.fullWidth, {['actionBoxWrapper']: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}>
    <div id="dv-action-box" className={stUtility.fullWidthPhablet}>
      <ActionBox />
    </div>
  </div>

const mapStateToProps = (state: IDetailPageState) => {
  return {
    hasCritical: atfCriticalDataSelector(state),
    renderOnlyGen4PlaybackInAtf: renderOnlyGen4PlaybackInAtfSelector(state),
    title: titleComponentSelector(state),
    metaData: metaDataSelector(state),
    synopsis: synopsisSelector(state),
    seasons: seasonsSelector(state),
    liveState: liveStateDataSelector(state),
    bannerPromo: bannerPromoSelector(state),
    heroQuickPromo: heroQuickPromoSelector(state),
    bundleCarousel: pageSelectors.bundleCarousel(state),
    crowBanner: crowBannerSelector(state),
    blockedPage: blockedPageSelector(state),
    isRetail: sanitizedRequestContextSelector(state).isRetail,
    bottomBar: bottomBarSelector(state),
    pageContext: state.pageContext,
    atfTreatment: simpleSelectors.atfTreatment(state),
    trailerAction: trailerComponentSelector(state),
    isDeeplinkableActionReady: isDeeplinkableActionReadySelector(state),
    isMshop: isMShopSelector(state),
    playbackMessaging: playbackMessagingComponentSelector(state),
    heroshotShouldBeShown: heroshotShouldBeShownSelector(state),
    ageVerification: ageVerificationSelector(state),
  }
}

export const AtfComponent = connect(mapStateToProps)(Atf)